import React from "react";

function CustomErrorView() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "90vh",
      }}
    >
      <h6>
        Something doesnt appear to be right. Are you sure you are in the right
        place?
      </h6>
    </div>
  );
}

export default CustomErrorView;
